import { gql } from '@apollo/client';

const GET_MERGED_PRACTICE_AREAS = gql`
  query GetMergedPracticeAreas {
    practiceAreasMerged {
      MergedPracticeAreaIds
      InternalId
      Name
      Acronym
    }
  }
`;

export default GET_MERGED_PRACTICE_AREAS;
